import React, { Component } from 'react'
import { Button, Modal } from '@driftt/tide'

class DeleteModal extends Component {

  render() {
    const { onDelete, onCancel, title, body } = this.props
      return (
        <Modal
          open={ true }
          type="warning"
          size="small"
          onClose={ onCancel }
          title={title}
        >
          <div className="delete-modal-content">
            <p className="delete-modal-body">{ body }</p>
            <footer className="delete-modal-button-section">
              <Button 
                className="delete-modal-buttons delete-modal-delete-button"
                type="secondary"
                size="medium"
                onClick={ onDelete }
              >
                Delete
              </Button>
              <Button 
                type="tertiary"
                className="delete-modal-buttons delete-modal-cancel-button"
                onClick={ onCancel }
              >
                Cancel
              </Button>
            </footer>
          </div> 
        </Modal>
        )
    }
}

export default DeleteModal